import { useQueryState } from 'nuqs';

import { DepthWaveWrapper } from '../../../../components/DepthWaveWrapper/DepthWaveWrapper';
import { Redirect } from '../../../../components/Redirect/Redirect';
import { useCurrentURL } from '../../../../helpers/hooks/useCurrentURL/useCurrentURL';
import { URLParameters } from '../../constants/url/urlParameters';
import { getFlow } from '../../helpers/flow/getFlow';

export const Fishbrain = () => {
  const { removeParameters } = useCurrentURL();
  const fallbackURL = removeParameters([URLParameters.Company, URLParameters.Flow]);
  const [flow] = useQueryState(URLParameters.Flow);
  const Flow = getFlow('fishbrain', flow);

  return (
    <DepthWaveWrapper logo>{Flow ? <Flow /> : <Redirect to={fallbackURL} />}</DepthWaveWrapper>
  );
};
